import { render, staticRenderFns } from "./AppDistrict.vue?vue&type=template&id=4770e1fd&"
import script from "./AppDistrict.vue?vue&type=script&lang=js&"
export * from "./AppDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports